import { Button, Modal, Dropdown } from 'react-bootstrap'
import { useState } from 'react'

const DownloadModal = ({ showModal, setShowModal, downloadCoupon }) => {
  const [couponType, setCouponType] = useState('WALLET')
  const COUPON_TYPE = ['WALLET', 'SAFE']

  return (
    <Modal
      className="fade bd-example-modal-lg"
      show={showModal}
      onHide={() => setShowModal(false)}
      onBackdropClick={() => setShowModal(false)}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>เลือกประเภทคูปองที่ต้องการดาวน์โหลด</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group row">
          <label className="col-sm-3 col-form-label">เลือกประเภทคูปอง: </label>
          <div className="col-sm-9">
            <div className="input-group mb-3 ">
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  {couponType || 'เลือกประเภทคูปอง'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {COUPON_TYPE.map((type) => (
                    <Dropdown.Item
                      key={type}
                      onClick={(e) => {
                        e.stopPropagation()
                        setCouponType(type)
                      }}
                    >
                      {type}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger light" onClick={() => setShowModal(false)}>
          ยกเลิก
        </Button>
        <Button key="submit" onClick={() => downloadCoupon(couponType)}>
          ดาวน์โหลดคูปอง
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DownloadModal
